export default "__VITE_ASSET__e12c2f90__"